// apps/dashboard/src/lib/consent-age.ts
//
// Client-side mirror of MARKETING_MIN_AGE (mirrors
// apps/api/src/modules/shared/is-adult.ts). The dashboard app cannot import
// from apps/api directly, so this constant is duplicated here rather than
// hardcoding 18/19 inline wherever the dashboard needs an age check. The
// server (writeMarketingConsent) is always the source of truth for the
// actual grant decision; any check here is a UI-only pre-check to avoid an
// unnecessary round trip, never the final word.
export const MARKETING_MIN_AGE = 18;

/** true when currentYear - birthYear > MARKETING_MIN_AGE (see is-adult.ts). */
export function isMarketingAdult(birthYear: number, currentYear: number): boolean {
  return currentYear - birthYear > MARKETING_MIN_AGE;
}

/**
 * true when `value` is a 4-digit string resolving to a plausible birth year
 * (1900..currentYear). Shared by every birth-year field so "4 digits" and
 * "a real year" mean the same thing everywhere, instead of some call sites
 * only checking digit count.
 */
export function isValidBirthYear(value: string, currentYear: number): boolean {
  if (!/^\d{4}$/.test(value)) return false;
  const year = Number(value);
  return year >= 1900 && year <= currentYear;
}
